import { IMcAppType, NavFlow, Tab } from "../mcApp.types";

export const evIChargeLinkingCallback: IMcAppType = {
  name: "evIChargeLinkingCallback",
  path: "/my/service/ev-icharge/linking/callback",
  description: "Power Up - Callback from enode for linking car account",
  navFlow: NavFlow.FOCUS,
  title: "Establishing connection",
  parent: Tab.DASHBOARD,
  conditions: {
    intent: "evIChargeLinkingCallback",
  },
};
